// Mock data for development when auth is faked

// Add a small collection of mock base64 PDF strings
// These are minimal valid PDF files encoded as base64 with correct A4 dimensions
const mockPdfBase64Strings = [
	// A4 sized PDF placeholder 1
	"JVBERi0xLjcKJeLjz9MKNSAwIG9iago8PAovVHlwZSAvWE9iamVjdAovU3VidHlwZSAvSW1hZ2UKL1dpZHRoIDU5NQovSGVpZ2h0IDg0MgovQ29sb3JTcGFjZSBbL0luZGV4ZWQgL0RldmljZVJHQiAxNSA8MDAwMDAwRkZGRkZGMDAwMEZGMEZGMDAwRkYwMDAwMEZGRkZGMDAwRkYwMDAwRkYwMEZGRkYwMEZGMDBGRkZGMEZGRkZGRkZGRkZGRkZGRkZGPl0KL0JpdHNQZXJDb21wb25lbnQgNAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDQ0IAo+PgpzdHJlYW0KeNpjZGRkZGRkZGJjZGJkYmRoZGZqYmJiYmJmYmVpZGFsYWFsHwUUAwBGDgRcCmVuZHN0cmVhbQplbmRvYmoKNyAwIG9iago8PAovVHlwZSAvUGFnZQovUGFyZW50IDEgMCBSCi9NZWRpYUJveCBbMCAwIDU5NS4yOCA4NDEuODldCi9Db250ZW50cyA4IDAgUgovUmVzb3VyY2VzIDw8Ci9YT2JqZWN0IDw8IC9JbTEgNSAwIFIgPj4KL1Byb2NTZXQgWy9QREYgL1RleHQgL0ltYWdlQiAvSW1hZ2VDIC9JbWFnZUldCj4+Cj4+CmVuZG9iago4IDAgb2JqCjw8Ci9MZW5ndGggMTQ5Cj4+CnN0cmVhbQowLjk1IDAuOSAwLjkgcmcKL0ltMSBEbwpCVAovRjkgMjAgVGYKMjUwIDQ1MCBUZAooTW9jayBQREYgRG9jdW1lbnQpIFRqCkVUCkJUCi9GOSAxMiBUZgoyMDAgNDMwIFRkCihQcm9wZXJ0eSBQb2xpY3kgRG9jdW1lbnQpIFRqCkVUCmVuZHN0cmVhbQplbmRvYmoKMSAwIG9iago8PAovVHlwZSAvUGFnZXMKL0tpZHMgWzcgMCBSIF0KL0NvdW50IDEKL01lZGlhQm94IFswIDAgNTk1LjI4IDg0MS44OV0KPj4KZW5kb2JqCjkgMCBvYmoKPDwKL1R5cGUgL0NhdGFsb2cKL1BhZ2VzIDEgMCBSCj4+CmVuZG9iagoxMCAwIG9iago8PAovUHJvZHVjZXIgKE1vY2sgUERGKQovQ3JlYXRpb25EYXRlIChEOjIwMjMwNjE1MTIwMDAwWikKPj4KZW5kb2JqCnhyZWYKMCAxMQowMDAwMDAwMDAwIDY1NTM1IGYgCjAwMDAwMDA2MzIgMDAwMDAgbiAKMDAwMDAwMDAwMCAwMDAwMCBmIAowMDAwMDAwMDAwIDAwMDAwIGYgCjAwMDAwMDAwMDAgMDAwMDAgZiAKMDAwMDAwMDAxNSAwMDAwMCBuIAowMDAwMDAwMDAwIDAwMDAwIGYgCjAwMDAwMDAyNjcgMDAwMDAgbiAKMDAwMDAwMDQzMCAwMDAwMCBuIAowMDAwMDAwNzE1IDAwMDAwIG4gCjAwMDAwMDA3NjQgMDAwMDAgbiAKdHJhaWxlcgo8PAovU2l6ZSAxMQovUm9vdCA5IDAgUgovSW5mbyAxMCAwIFIKPj4Kc3RhcnR4cmVmCjg0MQolJUVPRgo=",

	// A4 sized PDF placeholder 2
	"JVBERi0xLjcKJeLjz9MKNSAwIG9iago8PAovVHlwZSAvWE9iamVjdAovU3VidHlwZSAvSW1hZ2UKL1dpZHRoIDU5NQovSGVpZ2h0IDg0MgovQ29sb3JTcGFjZSBbL0luZGV4ZWQgL0RldmljZVJHQiAxNSA8MDAwMDAwRkZGRkZGMDAwMEZGMEZGMDAwRkYwMDAwMEZGRkZGMDAwRkYwMDAwRkYwMEZGRkYwMEZGMDBGRkZGMEZGRkZGRkZGRkZGRkZGRkZGPl0KL0JpdHNQZXJDb21wb25lbnQgNAovRmlsdGVyIC9GbGF0ZURlY29kZQovTGVuZ3RoIDQ0IAo+PgpzdHJlYW0KeNpjZGRkZGRiZGJiZGZkZGJmZGJmZGJmZGJmZGJmYmJgHwUUAwBGDQRZCmVuZHN0cmVhbQplbmRvYmoKNyAwIG9iago8PAovVHlwZSAvUGFnZQovUGFyZW50IDEgMCBSCi9NZWRpYUJveCBbMCAwIDU5NS4yOCA4NDEuODldCi9Db250ZW50cyA4IDAgUgovUmVzb3VyY2VzIDw8Ci9YT2JqZWN0IDw8IC9JbTEgNSAwIFIgPj4KL1Byb2NTZXQgWy9QREYgL1RleHQgL0ltYWdlQiAvSW1hZ2VDIC9JbWFnZUldCj4+Cj4+CmVuZG9iago4IDAgb2JqCjw8Ci9MZW5ndGggMTQ5Cj4+CnN0cmVhbQowLjk1IDAuOSAwLjkgcmcKL0ltMSBEbwpCVAovRjkgMjAgVGYKMjUwIDQ1MCBUZAooUG9saWN5IFNjcmVlbnNob3QpIFRqCkVUCkJUCi9GOSAxMiBUZgoyMDAgNDMwIFRkCihBdXRvIEluc3VyYW5jZSBQb2xpY3kpIFRqCkVUCmVuZHN0cmVhbQplbmRvYmoKMSAwIG9iago8PAovVHlwZSAvUGFnZXMKL0tpZHMgWzcgMCBSIF0KL0NvdW50IDEKL01lZGlhQm94IFswIDAgNTk1LjI4IDg0MS44OV0KPj4KZW5kb2JqCjkgMCBvYmoKPDwKL1R5cGUgL0NhdGFsb2cKL1BhZ2VzIDEgMCBSCj4+CmVuZG9iagoxMCAwIG9iago8PAovUHJvZHVjZXIgKE1vY2sgUERGKQovQ3JlYXRpb25EYXRlIChEOjIwMjMwNjE1MTIwMDAwWikKPj4KZW5kb2JqCnhyZWYKMCAxMQowMDAwMDAwMDAwIDY1NTM1IGYgCjAwMDAwMDA2MzIgMDAwMDAgbiAKMDAwMDAwMDAwMCAwMDAwMCBmIAowMDAwMDAwMDAwIDAwMDAwIGYgCjAwMDAwMDAwMDAgMDAwMDAgZiAKMDAwMDAwMDAxNSAwMDAwMCBuIAowMDAwMDAwMDAwIDAwMDAwIGYgCjAwMDAwMDAyNjcgMDAwMDAgbiAKMDAwMDAwMDQzMCAwMDAwMCBuIAowMDAwMDAwNzE1IDAwMDAwIG4gCjAwMDAwMDA3NjQgMDAwMDAgbiAKdHJhaWxlcgo8PAovU2l6ZSAxMQovUm9vdCA5IDAgUgovSW5mbyAxMCAwIFIKPj4Kc3RhcnR4cmVmCjg0MQolJUVPRgo=",
];

// Document types and issue scenarios
const documentTypes = [
	"Policy Document",
	"Coverage Agreement",
	"Endorsement",
	"Exclusion Rider",
	"Claim Form",
	"Declaration Page",
	"Premium Notice",
	"Insurance Certificate",
	"Policy Amendment",
	"Renewal Notice",
	"Cancellation Notice",
	"Disclosure Document",
];

const lineOfBusinessTypes = [
	"Property",
	"Auto",
	"Liability",
	"Workers Comp",
	"Commercial",
	"Marine",
	"Health",
	"Life",
	"Umbrella",
	"Professional",
	"Cyber",
	"Environmental",
];

const issueTypes = [
	"Critical",
	"Major",
	"Minor",
	"Technical",
	"Regulatory",
	"Compliance",
	"Wording",
	"Coverage Gap",
	"Definitional",
	"Procedural",
	"Pricing",
	"Documentation",
];

const issueNames = [
	"Missing Clause",
	"Conflicting Terms",
	"Unclear Wording",
	"Coverage Limitation",
	"Improper Exclusion",
	"Outdated Reference",
	"Incorrect Information",
	"Ambiguous Language",
	"Regulatory Non-compliance",
	"Missing Disclosure",
	"Contradictory Statements",
	"Misrepresented Coverage",
	"Incomplete Terms",
	"Improper Formatting",
	"Erroneous Calculation",
];

const keywords = [
	"Liability",
	"Coverage",
	"Exclusion",
	"Damage",
	"Injury",
	"Property",
	"Payment",
	"Claim",
	"Premium",
	"Deductible",
	"Endorsement",
	"Indemnity",
	"Peril",
	"Loss",
	"Cancellation",
	"Amendment",
	"Disclosure",
	"Limitation",
	"Provision",
	"Condition",
];

// Generate a large set of mock data items
const generateMockItems = (count = 1000) => {
	const items = [];

	for (let i = 1; i <= count; i++) {
		// Generate a keyword with position data (for the keyword positions cell renderer)
		const keyword = keywords[Math.floor(Math.random() * keywords.length)];
		const pageText = `This is a mock policy document containing various terms including ${keyword} and other relevant information. The ${keyword} clause is particularly important for understanding the coverage limits and conditions. Please review this document carefully to understand all terms and conditions related to your policy.`;

		// Create random positions for the keyword in the text
		const keywordIndices = [];
		let position = pageText.indexOf(keyword);
		while (position !== -1) {
			keywordIndices.push([position, position + keyword.length]);
			position = pageText.indexOf(keyword, position + 1);
		} // Create the keyword positions object
		const ruleKeywordObj = {
			pageText,
			keywordPositions: {
				[keyword]: keywordIndices,
			},
		};

		// Get a random base64 PDF string from our collection
		const pdfBase64 =
			mockPdfBase64Strings[
				Math.floor(Math.random() * mockPdfBase64Strings.length)
			];

		items.push({
			id: i,
			sn: i,
			documentName: `${documentTypes[Math.floor(Math.random() * documentTypes.length)]} ${i}`,
			lineOfBusiness:
				lineOfBusinessTypes[
					Math.floor(Math.random() * lineOfBusinessTypes.length)
				],
			issueName: issueNames[Math.floor(Math.random() * issueNames.length)],
			result: Math.random() > 0.5 ? "Issue" : "Non-Issue",
			confirmResult: Math.random() > 0.5 ? "Issue" : "Non-Issue",
			issueType: issueTypes[Math.floor(Math.random() * issueTypes.length)],
			pageNumber: String(Math.floor(Math.random() * 100) + 1),
			formNumber:
				Math.random() > 0.7
					? `FORM-${i}-${Math.floor(Math.random() * 1000)}`
					: "",
			permanentStatus: [null, "Pending", "Resolved", "Rejected"][
				Math.floor(Math.random() * 4)
			],
			ruleKeyword: ruleKeywordObj,
			policyPageScreenshot: pdfBase64,
		});
	}

	return items;
};

// Function to get paginated data
export const getPaginatedMockData = (page = 1, pageSize = 100) => {
	// Generate or get cached items
	const allItems = generateMockItems(1000);
	const totalItems = allItems.length;
	const totalPages = Math.ceil(totalItems / pageSize);

	// Calculate the start and end indices for the requested page
	const startIndex = (page - 1) * pageSize;
	const endIndex = Math.min(startIndex + pageSize, totalItems);

	// Slice the data to get just the items for the requested page
	const paginatedItems = allItems.slice(startIndex, endIndex);

	return {
		pagination: {
			currentPage: page,
			pageSize,
			totalItems,
			totalPages,
		},
		data: paginatedItems,
	};
};

// Legacy export for backward compatibility
export const mockOutputReviewData = getPaginatedMockData(1, 100);
